import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IComment } from "src/pages/Summary/Summary.types";

export interface IToVerifyItem {
  id: string;
  idType: string;
}
interface VerifySlice {
  toVerify: IToVerifyItem[];
  comments: IComment[];
}

const initialState: VerifySlice = {
  toVerify: [],
  comments: [],
};

export const verifySlice = createSlice({
  name: "verifySlice",
  initialState,
  reducers: {
    addToVerify: (state, action: PayloadAction<IToVerifyItem>) => {
      state.toVerify.push(action.payload);
    },
    removeFromVerify: (state, action: PayloadAction<IToVerifyItem>) => {
      state.toVerify = state.toVerify.filter(e => e.id !== action.payload.id);
    },
    setToVerify: (state, action: PayloadAction<IToVerifyItem[]>) => {
      state.toVerify = action.payload;
    },
    setComments: (state, action: PayloadAction<IComment[]>) => {
      state.comments = action.payload;
    },
    resetVerifySlice: state => ({
      ...state,
      toVerify: [],
      comments: [],
    }),
  },
});

export const {
  addToVerify,
  setToVerify,
  removeFromVerify,
  setComments,
  resetVerifySlice,
} = verifySlice.actions;

export default verifySlice.reducer;
